import { render } from "./userFoot.vue?vue&type=template&id=2fa18856"
import script from "./userFoot.vue?vue&type=script&lang=js"
export * from "./userFoot.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__